export default __webpack_public_path__ + "static/media/soundcloud.6ed7ed0b.svg";